module.exports = __webpack_public_path__ + "img/pos-icon-dark.2417163d.svg";